import { render, staticRenderFns } from "./phoneShow.vue?vue&type=template&id=6fb316d4&scoped=true"
import script from "./phoneShow.vue?vue&type=script&lang=js"
export * from "./phoneShow.vue?vue&type=script&lang=js"
import style0 from "./phoneShow.vue?vue&type=style&index=0&id=6fb316d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb316d4",
  null
  
)

export default component.exports